/* eslint-disable no-console */
/* eslint-disable import/first */
/* eslint-disable no-case-declarations */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useCallback, useState } from 'react';
import enGB from 'date-fns/locale/en-GB';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import formatRelative from 'date-fns/formatRelative';
import { useNavigate, useLocation } from '@reach/router';
import { RiErrorWarningLine } from '@react-icons/all-files/ri/RiErrorWarningLine';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Button, Radio, Grid } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
const { postOrder, getPaymentMethod, getAdvanceSlots, getOrder } = Slices.orderSlice;
const { selectAuthId, selectLoginStatus } = Slices.authSlice;
const { storeInstruction, extraDetail, selectDesktop, goGreenSelector } = Slices.appSlice;
const { clearCart, sendCart } = Slices.cartSlice;
const { getFirebaseToken, getFirestoreStatus } = Slices.arcSlice;
import LanguageButton from '../../components/LanguageButton';
const { fetchSavedCards, enableLightPay } = Slices.homeSlice;
import cardIcon from './images/creditcard.svg';
import visaIcon from './images/clickToPay.svg';
import samsungIcon from './images/samsung.png';
import applepayIcon from './images/applepay.svg';
import arrow from './images/arrow.svg';
import knetIcon from './images/knet.svg';
import cashIcon from './images/cash.svg';
import ReviewCartPopUp from '../Cart/ReviewCartPopUp';
import Loader from '../../components/Loader';
import { BsChevronDown } from '@react-icons/all-files/bs/BsChevronDown';
import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { Badge } from '../../components/Icons';
import ProfileCard from './ProfileCard';
import OrderMode from './OrderMode';
import ChangeAddressBox from './ChangeAddressBox';
import CartValue from './CartValue';
import ErrorBoundary from '../../components/ErrorBoundary';
import DrawerPwa from '../../components/DrawerPwa';
import Header from '../../components/Header';
const { selectCountryValidations, selectPaymentMethodConstants } = Slices.configSlice;
const { selectCurrentCountry, getCurrentProfile } = Slices.profileSlice;
import GoGreen from '../Cart/GoGreen';

import CartBar from '../../components/CartBar';
import PaymentMethodDrawer from './PaymentMethodDrawer';
import SavedAddressDrawer from './SavedAddressDrawer';
import { Context } from '../../components/Multi-lang/Wrapper';
import Skeleton from 'react-loading-skeleton';
import css from './index.module.scss';
import {
  fillingShippingDetailsGA,
  makePaymentGA,
  orderCompletedGA,
  paymentAttemptGA,
  paymentInfoSubmittedGA,
  shippingInfoSubmittedGA,
} from 'spwa-ui-library/esm/utils/helperGA';
const { selectFirstMenu } = Slices.menuSlice;
const { couponCodeApplied, removeApply } = Slices.offerSlice;
import DialogBox from '../../components/DialogBox';
const { selectAddressRootState, selectDefaultAddress } = Slices.addressSlice;
const { getClusterId } = Slices.configSlice;
import CustomError from './CustomError';
import FutureSlots from './FutureSlots';
import {
  authenticateUserToken,
  orderFirestoreListener,
} from 'spwa-ui-library/esm/library/firebase';
import EnableLightningPayModal from './EnableLightningPayModal';
import LightningPayTimer from './LightningPayTimer';
import LightningPayProcessing from './LightningPayProcessing';
import LightningPayToggle from '../../components/LightningPayToggle';
import LightningPayStatus from './LightningPayStatus';
import classNames from 'classnames';

let noonpayBspExpirationTimer;
let noonpayBspFirestoreRetryInterval;
let noonpayBspFirestoreRetry;

function Checkout({ foodInstr, handleFoodInstr }) {
  const [selectedValue, setSelectedValue] = React.useState('now');
  const [selectedDate, setSelectedDate] = React.useState(0);
  const [selectedTime, setSelectedTime] = React.useState(0);
  const [slotList, setSlotList] = React.useState([]);
  const intl = useIntl();
  const location = useLocation();
  const cart = useSelector((state) => state.cart);
  const storeInst = useSelector(storeInstruction);
  const extraInst = useSelector(extraDetail);
  const auth = useSelector((state) => state.auth);
  const clusterId = useSelector(getClusterId);
  const goGreenConfig = useSelector((state) => state.cart.goGreen);

  // const address = useSelector(selectAddressRootState);
  // eslint:fix
  const defaultAddress = useSelector(selectDefaultAddress);
  const address = useSelector(selectAddressRootState);
  const cartId = useSelector(selectAuthId);
  const selectorGoGreen = useSelector(goGreenSelector);
  const profile = useSelector((state) => state.profile);
  const currentProfileObj = useSelector(getCurrentProfile);
  const offer = useSelector((state) => state.offer);
  const menu = useSelector(selectFirstMenu);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paymentMethodConst = useSelector(selectPaymentMethodConstants);
  const [stateOpen, setStateOpen] = React.useState(false);
  const [stateAddress, setStateAddress] = React.useState(false);
  const [errorResponse, setErrorResponse] = React.useState('');
  const [errorType, setErrorType] = React.useState(null);
  const [previousPaymentMode, setPreviousPaymentMode] = useState(undefined);
  const [paymentMethod, setPaymentMethod] = React.useState([]);
  const [methodType, setMethodType] = React.useState('');
  const [methodTypeIcon, setMethodTypeIcon] = React.useState('');
  const [paymentMode, setPaymentMode] = React.useState(null);
  const [paymentOpen, setPaymentOpen] = React.useState(false);
  const [futureDrawer, setFutureDrawer] = React.useState(false);
  const [paymentApiStatus, sePaymentApiStatus] = React.useState(false);
  const [customCartId, setCustomCartID] = React.useState('');
  const [disableMakePayment, setDisableMakePayment] = React.useState(false);
  const [saveCardData, setSaveCardData] = useState({});
  const [cardToken, setCardToken] = React.useState('');
  const [slots, setSlots] = React.useState([]);
  const [checked, setChecked] = React.useState(true);
  const context = useContext(Context);
  const [cardNumber, setCardNumber] = React.useState('');
  const categoryList = useSelector((state) => state.category);
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const user = useSelector(selectLoginStatus);
  const offerSelected = useSelector(couponCodeApplied);
  const currency = menu && menu.currency;
  const isDesktop = useSelector(selectDesktop);
  const [contactLessStatus, setContactLessStatus] = React.useState(true);
  const [pageLoader, setPageLoader] = React.useState(false);
  const [subPayment, setSubPayment] = React.useState(null);
  const [subHeading, setSubHeading] = React.useState('');
  const [futureError, setFutureError] = React.useState('');
  const [reviewError, setReviewError] = React.useState('');
  const [reviewPop, setReviewPop] = React.useState('');
  //Lightning pay modal state;
  const [enableLightningPay, setEnableLightningPay] = React.useState(false);
  const [lightningPayTimer, setLightningPayTimer] = React.useState(false);
  const [lightningPayStatusModal, setLightningPayStatusModal] = React.useState(false);
  const [lightningPayProcessing, setLightningPayProcessing] = React.useState(false);
  const [orderId, setOrderId] = React.useState(false);
  const [isEnableLighteningPayOnNextOrder, setIsEnableLighteningPayOnNextOrder] = React.useState(
    false
  );
  useEffect(() => {
    setReviewError(reviewPop);
  }, [reviewPop]);
  const promoObj = cart.data.promo || {};
  const enableBinPromo = promoObj?.noonPayPromoid && promoObj?.noonPayPromoid !== '' ? true : false;

  const cartValues = {
    SUB_TOTAL: 'Sub Total',
    SHIPPING: 'Delivery',
    TOTAL: 'Total',
  };

  const paymentHeading = {
    CARD: intl.formatMessage({ id: 'checkout_pay_card' }),
    VISA_CHECKOUT: intl.formatMessage({ id: 'checkout_click_pay' }),
    SAMSUNG_PAY: intl.formatMessage({ id: 'checkout_samsung_pay' }),
    GOOGLE_PAY: intl.formatMessage({ id: 'checkout_google_pay' }),
    POD: intl.formatMessage({ id: 'checkout_pod' }),
    KNET: intl.formatMessage({ id: 'checkout_knet' }),
    APPLE_PAY: intl.formatMessage({ id: 'checkout_applePay' }),
    COD: intl.formatMessage({ id: 'checkout_pod' }),
    CCOD: 'Credit / Debit',
  };

  const iconList = {
    CARD: cardIcon,
    VISA_CHECKOUT: visaIcon,
    SAMSUNG_PAY: samsungIcon,
    GOOGLE_PAY: samsungIcon,
    APPLE_PAY: applepayIcon,
    KNET: knetIcon,
    POD: cashIcon,
    COD: cashIcon,
    CCOD: cardIcon,
  };

  const handlePayment = (id, mainId = null) => {
    if (selectedValue === 'future' && (id === 100 || id === 0)) {
      // eslint:fix false is returned because it was a empty block statement
      return false;
    } else {
      setPaymentMode(id === 0 ? id?.toString() : id || mainId);

      if (id !== 100 || id !== 0) setSubPayment((prv) => null);
      // setCardToken('');
      // if (id !== 'handlePayment') {
      //   setCardToken('');
      // }
    }
  };

  const firestoreStatusHandler = async (orderId) => {
    if (noonpayBspFirestoreRetry > 0) {
      noonpayBspFirestoreRetry = noonpayBspFirestoreRetry - 1;
      const firestoreStatus = await dispatch(getFirestoreStatus(orderId));
      if (!firestoreStatus.payload.data.data.noonpayRedirectionUrl) {
        noonpayBspFirestoreRetryInterval = setTimeout(() => {
          firestoreStatusHandler(orderId);
        }, countryValidations.noonpayBspFirestoreRetryInterval * 1000);
      } else {
        setPageLoader(false);
        window.location.replace(firestoreStatus.payload?.data?.data?.noonpayRedirectionUrl);
      }
    } else {
      const firestoreError = await dispatch(getFirestoreStatus(orderId));
      setStateOpen(true);
      setPageLoader(false);
      setErrorType(firestoreError.payload);
      setErrorResponse(firestoreError.payload.message);
    }
  };

  const getFirebaseTokenHandler = async (orderId, isLightningPay) => {
    if (!isLightningPay) {
      setPageLoader(true);
    }
    const firebaseTokenRes = await dispatch(getFirebaseToken());
    const authenticateUser = await authenticateUserToken(firebaseTokenRes.payload.data.data);
    const orderListner = await orderFirestoreListener(authenticateUser.user.uid, orderId);
    orderListner.onSnapshot((doc) => {
      if (doc.data()) {
        setPageLoader(false);
        if (doc.data()?.noonpayRedirectionUrl !== '') {
          window.location.replace(doc.data()?.noonpayRedirectionUrl);
        } else if (doc.data()?.lightningPayEnable) {
          setLightningPayProcessing(false);
          setPageLoader(false);
          if (doc.data()?.orderStatus === 'FAILURE') {
            setLightningPayStatusModal(true);
          } else {
            dispatch(clearCart());
            dispatch(removeApply());
            navigate(`/${intl.locale}/thank-you/` + doc.data()?.orderId, {
              state: {
                lightningPaySuccess: true,
              },
            });
          }
        }
        clearTimeout(noonpayBspExpirationTimer);
        clearTimeout(noonpayBspFirestoreRetryInterval);
      }
    });
    noonpayBspExpirationTimer = setTimeout(async () => {
      noonpayBspFirestoreRetry = countryValidations.noonpayBspFirestoreRetry;
      firestoreStatusHandler(orderId);
    }, countryValidations.noonpayBspExpirationTime * 1000);
  };

  useEffect(() => {
    if (paymentMethod) {
      const mainMethod = paymentMethod?.filter((val) => val.id === 100 || val.id === 0);
      const subValue = mainMethod[0]?.paymentModes?.filter((innerSub) => innerSub.id === subPayment);
      setSubHeading((subValue && subValue[0]?.name) || '');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subPayment]);

  const handleCardToken = (tokenId) => {
    setCardToken(tokenId);
  };

  const handleChangeCheckbox = () => {
    setChecked(!checked);
  };
  useEffect(() => {
    if (Object.entries(defaultAddress).length) {
      const futurePayLoad = {
        addressId: defaultAddress.id,
        orderType: defaultAddress.addressType,
      };
      dispatch(getAdvanceSlots(futurePayLoad)).then((rep) => {
        if (rep.meta.requestStatus !== 'rejected') {
          if (!rep?.payload?.data?.data[0]?.slots) {
            setFutureDrawer(false);
            setFutureError('not');
          } else {
            setFutureError('');
          }
        } else {
          setFutureError(rep.payload.data.message);
          setSelectedValue('now');
          setFutureDrawer(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultAddress, cart.status]);
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    if (event.target.value === 'future') {
      const futurePayLoad = {
        addressId: defaultAddress.id,
        orderType: defaultAddress.addressType,
      };
      dispatch(getAdvanceSlots(futurePayLoad)).then((rep) => {
        if (rep.meta.requestStatus !== 'rejected') {
          setSlots(rep?.payload?.data?.data || []);
          setFutureError('');
          setSelectedDate(
            selectedDate ? selectedDate : rep?.payload?.data?.data[0]?.date[0]?.value
          );
          setSlotList(rep?.payload?.data?.data[0]?.slots || []);
          setSelectedTime(
            selectedTime ? selectedTime : rep?.payload?.data?.data[0]?.slots[0]?.value
          );
          if (!rep?.payload?.data?.data[0]?.slots) {
            setFutureDrawer(false);
            setFutureError('not');
          }
        } else {
          setFutureError(rep.payload.data.message);
          setSelectedValue('now');
          setFutureDrawer(false);
        }
      });

      setFutureDrawer(true);
    } else {
      refreshCart(true);
    }
  };
  const openFuture = () => {
    setSelectedValue('future');
    const futurePayLoad = {
      addressId: defaultAddress.id,
      orderType: defaultAddress.addressType,
    };
    dispatch(getAdvanceSlots(futurePayLoad)).then((rep) => {
      if (rep.meta.requestStatus !== 'rejected') {
        setSlots(rep?.payload?.data?.data || []);
        setFutureError('');
        setSelectedDate(selectedDate ? selectedDate : rep?.payload?.data?.data[0]?.date[0]?.value);
        setSlotList(rep?.payload?.data?.data[0]?.slots || []);
        setSelectedTime(selectedTime ? selectedTime : rep?.payload?.data?.data[0]?.slots[0]?.value);
      } else {
        setFutureError(rep.payload.data.message);
        setSelectedValue('now');
        setFutureDrawer(false);
      }
    });

    setFutureDrawer(true);
  };

  const handleClickAway = () => {
    setStateOpen(false);
    closePaymentPopup();
  };
  // const handleClickAwayFuture = () => {
  //   setFutureDrawer(false);
  // };

  const makePayment = (event) => {
    handlePaymentDrawer();
    if (isDesktop) {
      sendOrderToMs();
    }
  };

  const redirectToThankyouPage = () => {
    dispatch(clearCart());
    dispatch(removeApply());
    navigate(`/${intl.locale}/thank-you/` + orderId);
  };

  const postOrderHandler = (event, tokenSavedCard, isLightningPay, firstTimeLightningPay, overridePaymentMode) => {
    const selectedCard = getCardDetailByNo(cardNumber);
    setEnableLightningPay(false);
    setLightningPayTimer(false);
    setPaymentOpen((prev) => false);
    setDisableMakePayment(true);
    if (isLightningPay && selectedCard?.subscription?.identifier) {
      setLightningPayProcessing(true);
    } else {
      setPageLoader(true);
    }
    let NewPayment;

    if (event && !isNaN(event)) {
      NewPayment = event;
    } else {
      NewPayment = paymentMode;
    }
    const inst = window.localStorage.getItem('dInst')
      ? window.localStorage.getItem('dInst') + ', '
      : '';
    let deliveryInstruction = inst + extraInst;
    if (deliveryInstruction) {
      deliveryInstruction = deliveryInstruction + ', ' + selectorGoGreen;
    } else {
      deliveryInstruction = selectorGoGreen;
    }

    let methodId;

    if(overridePaymentMode !== undefined) {
      methodId = overridePaymentMode;
    } else {
      if (!cardToken && cardToken !== '') {
        methodId = 1;
      } else {
        if (subPayment === null || subPayment === 0 || !subPayment) {
          if (NewPayment === 100 || NewPayment == 0) {
            methodId = subPayment;
          } else {
            methodId = NewPayment;
          }
        } else {
          methodId = NewPayment;
        }
      }
    }

    if (!methodId) {
      methodId = 0;
    }

    setPreviousPaymentMode((_) => methodId);

    const newToken = tokenSavedCard || cardToken;
    const foodinstruction = cart.cookingData || '';
    const isExist = paymentMethod.findIndex(({ id }) => id === NewPayment);
    const payment_type = cardToken === '' && paymentMethod[isExist]?.name;

    let payload = {
      addressId: defaultAddress.id,
      advanceTime:
        selectedTime && selectedValue === 'future'
          ? `${format(selectedDate, 'yyyy-MM-dd')} ${selectedTime.split(' ')[1]}`
          : '', // ! COMMENTED FOR NOW
      cartId: customCartId,
      clusterId: clusterId,
      hash: cart?.data?.hash || '',
      contactlessDlvry: contactLessStatus ? 1 : 0,
      couponCode: cart.data?.couponApplied ? cart?.data?.promo?.couponCode : '',
      dineInTableNo: 0, // TODO: Update with relevent data
      reOrderId: '', // TODO: Update with relevent data
      version: 'v20', // TODO: Move to BFF
      foodInstr: foodinstruction,
      createNewOrder: event === 'newOrder' ? 1 : 0,
      dlvryInstr: deliveryInstruction,
      enableLightningPay: isLightningPay || firstTimeLightningPay ? 'ENABLE' : '',
      makeDefaultPaymentMethod: checked,
      orderType: defaultAddress.addressType,
      paymentMethodId: methodId,
      paymentMethodSubscriptionSource: '', // TODO: Update with relevent data
      // paymentMethodSource: newToken !== '' ? newToken : paymentMode === 100 ? 'POD' : payment_type, // ! COMMENTED FOR NOW
      storeInstr: storeInst || '',
      trueCuntry: country?.toUpperCase(),
    };
    if (cardNumber && isLightningPay) {
      payload.paymentMethodSubscriptionSource = selectedCard?.subscription?.identifier;
    }

    if (
      newToken !== null &&
      newToken !== 'null' &&
      newToken !== undefined &&
      newToken !== 'undefined' &&
      newToken !== '' &&
      !overridePaymentMode
    ) {
      payload.paymentMethodSource = newToken;
      payload.paymentMethodId = 1;
    }

    try {
      dispatch(postOrder(payload))
        .then(async (resp) => {
          if (resp?.meta?.requestStatus !== 'rejected') {
            try {
              setDisableMakePayment(false);
              const orderType = defaultAddress.addressSubType;
              const orderId = resp.payload.data.data.orderPlaced.orderInfo.uOrderRef;
              //pass only resp in the following GAs and no other paramenters
              paymentInfoSubmittedGA(
                payment_type,
                cart,
                currency,
                categoryList,
                offerSelected,
                defaultAddress
              );
              fillingShippingDetailsGA(cart, user, categoryList);
              makePaymentGA(cart, user, categoryList);
              // dispatch(clearCart());
              const orderPlaced = resp.payload.data.data.orderPlaced;

              if (orderPlaced?.noonpayRedirectionUrl !== '' || orderPlaced?.firestoreEnable) {
                // dispatch(clearCart());
                // navigate(`/${intl.locale}/payment`);

                if (orderPlaced?.firestoreEnable) {
                  getFirebaseTokenHandler(
                    resp.payload.data.data.orderPlaced.orderInfo._id,
                    isLightningPay && selectedCard?.subscription?.identifier
                  );
                } else {
                  if (isLightningPay && selectedCard?.subscription?.identifier) {
                    setLightningPayProcessing(false);
                  } else {
                    setPageLoader(false);
                  }
                  window.location.href = orderPlaced?.noonpayRedirectionUrl;
                  setDisableMakePayment(false);
                }
              } else {
                orderCompletedGA(
                  cart,
                  currency,
                  orderType,
                  categoryList,
                  offerSelected,
                  orderId,
                  methodId,
                  defaultAddress
                );

                window.localStorage.setItem('_PMI', cardToken !== '' ? 1 : payload.paymentMethodId);
                window.localStorage.setItem('_MPS', payload.paymentMethodSource || '');

                if (isLightningPay && selectedCard?.subscription?.identifier) {
                  setLightningPayProcessing(false);
                } else {
                  setPageLoader(false);
                }
                if (subPayment !== null) {
                  window.localStorage.setItem('_SubP', subPayment);
                }
                if (isLightningPay && orderPlaced?.orderInfo?.status === 'FAILURE') {
                  setLightningPayStatusModal(true);
                } else if (isLightningPay) {
                  // setLightningPayStatusModal(true);
                  // setOrderId(orderPlaced.orderInfo._id);
                  dispatch(clearCart());
                  dispatch(removeApply());
                  navigate(`/${intl.locale}/thank-you/` + orderPlaced.orderInfo._id, {
                    state: {
                      lightningPaySuccess: true,
                    },
                  });
                } else {
                  dispatch(clearCart());
                  dispatch(removeApply());
                  navigate(`/${intl.locale}/thank-you/` + orderPlaced.orderInfo._id);
                }
                setDisableMakePayment(false);
              }
            } catch (errorInner) {
              if (isLightningPay && selectedCard?.subscription?.identifier) {
                setLightningPayProcessing(false);
              } else {
                setPageLoader(false);
              }
              console.log(errorInner, 'error');
            }
          } else {
            try {
              if (isLightningPay && selectedCard?.subscription?.identifier) {
                setLightningPayProcessing(false);
              } else {
                setPageLoader(false);
              }
              setDisableMakePayment(false);
              setPaymentOpen(false);
              setStateOpen(true);
              if (resp?.payload?.data?.statusCode) {
                setErrorType(resp?.payload);
              } else {
                setErrorType(null);
              }
              setErrorResponse(resp?.payload?.data?.message || 'Something went wrong');
            } catch (errorLog) {
              if (isLightningPay && selectedCard?.subscription?.identifier) {
                setLightningPayProcessing(false);
              } else {
                setPageLoader(false);
              }
              console.log(errorLog);
            }
            // console.log(resp.payload.data, 'resp');
          }
        })
        .catch((error) => {
          console.log(error);
          setLightningPayProcessing(false);
          if (isLightningPay && selectedCard?.subscription?.identifier) {
            setLightningPayProcessing(false);
          } else {
            setPageLoader(false);
          }
          setDisableMakePayment(false);
          setPaymentOpen(false);
          setStateOpen(true);
          setErrorType(error);
          setErrorResponse(error);
        });
      paymentAttemptGA(user, payment_type, cart.data.orderType, cart?.data?.amount, defaultAddress);
    } catch (errorMain) {
      if (isLightningPay && selectedCard?.subscription?.identifier) {
        setLightningPayProcessing(false);
      } else {
        setPageLoader(false);
      }
      console.log(errorMain);
    }
  };

  const sendOrderToMs = (event, tokenSavedCard, lightningPay, lightningPayLater, overridePaymentMode) => {
    setIsEnableLighteningPayOnNextOrder(lightningPay);
    setEnableLightningPay(false);
    let isLightningPay = false;
    const selectedCard = getCardDetailByNo(cardNumber);
    if (
      cardNumber &&
      cardToken &&
      cart.cartValue <= countryValidations.lightningPayConfig?.lightningPayMaxAmount &&
      !lightningPayLater &&
      cart.cartValue <= countryValidations.lightningPayConfig?.lightningPayMaxAmount &&
      selectedCard?.lightningPayActive
    ) {
      isLightningPay = selectedCard.lightningPayActive;
    }
    if(overridePaymentMode) {
      isLightningPay = false;
      lightningPay = false
    }

    if (event === 'newOrder') {
      postOrderHandler(event, tokenSavedCard, isLightningPay, lightningPay, overridePaymentMode);
    } else {
      if (isLightningPay && !lightningPayTimer && selectedCard?.subscription?.identifier) {
        setLightningPayTimer(true);
      } else {
        postOrderHandler(event, tokenSavedCard, isLightningPay, lightningPay, overridePaymentMode);
      }
    }
  };

  const handleSetLastPayment = useCallback(() => {
    let firstorder = 0;
    firstorder = {
      paymentMethodGroupId: +window.localStorage.getItem('_PMI') || null,
      paymentMethodSource: window.localStorage.getItem('_MPS') || null,
      subPayment: +window.localStorage.getItem('_SubP'),
    };
    if (customCartId && Object.entries(defaultAddress).length && !enableBinPromo) {
      let payload = {
        isActive: 1,
        page: 1,
      };

      // setLastPayment((prev) => firstorder);
      // console.log(lastPayment);
      if (firstorder.paymentMethodGroupId !== null) {
        const methodPayload = {
          cartId: customCartId,
          addressId: defaultAddress.id,
          addressSubType: defaultAddress.addressSubType,
        };
        dispatch(getPaymentMethod(methodPayload)).then((resp) => {
          const payment = resp.payload.data.data.availableMethods;
          const subType = defaultAddress.addressSubType;
          const advanceMethods = countryValidations.advanceOrderServiceStatus.filter(
            (each) => each.type === subType
          );
          const modesToCheck = advanceMethods[0].PAYMENT_METHODS;
          if (selectedValue === 'future') {
            const filterPaymentList = payment.filter((item) => {
              if (item.paymentModes) {
                const checkInner = item.paymentModes.filter(
                  (inner) => modesToCheck.includes(inner.id) && inner.active
                );
                if (checkInner.length) {
                  return item;
                }
              } else if (modesToCheck.includes(item.id) && item.active) {
                return item;
              }
              return null;
              // eslint:fix return null because filter should return some value
            });
            setPaymentMethod(filterPaymentList);
          } else {
            setPaymentMethod(payment);
          }
          if (firstorder.paymentMethodGroupId === 1 && firstorder.paymentMethodSource !== null) {
            setCardToken(firstorder.paymentMethodSource);
            dispatch(fetchSavedCards()).then((retVal) => {
              const cardsData = retVal?.payload?.data?.data || [];
              const filterCard = cardsData?.userCards.filter(
                (val) => val.token === firstorder.paymentMethodSource
              );
              setCardNumber((prev) => filterCard[0]?.cardNo);
            });
          }
          const checkItem = payment.filter(
            (values) =>
              values.id === firstorder.paymentMethodGroupId &&
              values.active === 1 &&
              values.default === 1
          );
          if (checkItem.length && firstorder.paymentMethodGroupId !== 0) {
            setPaymentMode(firstorder.paymentMethodGroupId);
          } else {
            if (firstorder.subPayment !== null && firstorder.paymentMethodGroupId === 0) {
              let checkSub = true;
              const defaultMethod = payment?.filter((method) => method?.default);

              if (Array.isArray(defaultMethod) && defaultMethod?.length > 0) {
                setPaymentMode(
                  defaultMethod[0]?.id === 0
                    ? defaultMethod[0]?.id?.toString()
                    : defaultMethod[0]?.id
                );
                setSubPayment(null);
                setSubHeading(defaultMethod[0].name);
                checkSub = false;
              }
              // const checkSubPayment = payment.map((val) => {
              //   if (val.paymentModes?.length > 0) {
              //     const ifExist = val.paymentModes.filter(
              //       (subit) =>
              //         subit.id === firstorder.subPayment && subit.active === 1 && subit.default
              //     );
              //     if (ifExist?.length) {
              //       if (selectedValue !== 'future') {
              //         setPaymentMode(firstorder.paymentMethodGroupId);
              //         setSubPayment(firstorder.subPayment);
              //         setSubHeading(ifExist[0].name);
              //         checkSub = false;
              //       } else {
              //         const ifExist = val.paymentModes.filter(
              //           (subit) =>
              //             subit.id === firstorder.subPayment &&
              //             subit.active === 1 &&
              //             subit.default &&
              //             subit.advanceOrderEnabled === 1
              //         );
              //         if (ifExist.length) {
              //           setPaymentMode(firstorder.paymentMethodGroupId);
              //           setSubPayment(firstorder.subPayment);
              //           setSubHeading(ifExist[0].name);
              //           checkSub = false;
              //         }
              //       }
              //     } else {
              //       setSubPayment(null);
              //     }
              //   }
              // });
              // eslint:fix checkSubPayment is defined but never used
              if (
                selectedValue === 'future' &&
                (firstorder.paymentMethodGroupId === 100 || firstorder.paymentMethodGroupId === 0)
              ) {
                setPaymentMode(null);
              }

              if (checkSub) {
                setPaymentMode(firstorder.paymentMethodGroupId);
              }
            }
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customCartId, selectedValue]);

  useEffect(() => {
    handleSetLastPayment();
  }, [customCartId, selectedValue]);

  useEffect(() => {
    if (selectedValue === 'future' && (paymentMode === 100 || paymentMode === 0)) {
      setPaymentMode(null);
    }
  }, [selectedValue, paymentMode]);
  const checkOut = () => {
    if (reviewPop === '') {
      if (Object.entries(defaultAddress).length === 0) {
        if (isDesktop) {
          navigate(`${location.pathname}?modal=${'DELIVERY'.toLowerCase()}`);
        } else {
          navigate(`/${intl.locale}/addresses/select`, { replace: true });
        }
      } else {
        const methodPayload = {
          cartId: customCartId,
          addressId: defaultAddress.id,
          addressSubType: defaultAddress.addressSubType,
        };
        dispatch(getPaymentMethod(methodPayload))
          .then((resp) => {
            const payment = resp.payload.data.data.availableMethods;
            const subType = defaultAddress.addressSubType;
            const advanceMethods = countryValidations.advanceOrderServiceStatus.filter(
              (each) => each.type === subType
            );

            const modesToCheck = advanceMethods[0].PAYMENT_METHODS;
            if (selectedValue === 'future') {
              const filterPaymentList = payment.filter((item) => {
                if (item.paymentModes) {
                  const checkInner = item.paymentModes.filter(
                    (inner) => modesToCheck.includes(inner.id) && inner.active
                  );
                  if (checkInner.length) {
                    return item;
                  } else {
                    return null;
                  }
                } else if (modesToCheck.includes(item.id) && item.active) {
                  return item;
                } else {
                  return null;
                }
              });

              setPaymentMethod(filterPaymentList);
            } else {
              setPaymentMethod(payment);
            }

            sePaymentApiStatus(true);
          })
          .catch((e) => {
            console.log(e);
          });
        setPaymentOpen(true);
      }
    } else {
      setReviewError(reviewPop);
    }
  };

  useEffect(() => {
    if (cart.status === 'succeeded' && !cart.data?.items?.length) {
      navigate(`/${intl.locale}/home`, { replace: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart.status, defaultAddress]);

  useEffect(() => {
    if (
      address?.status == 'succeeded' &&
      Object.entries(defaultAddress).length === 0 &&
      cart.status === 'succeeded' &&
      auth.isLoggedIn
    ) {
      navigate(`/${intl.locale}/cart`, { replace: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, defaultAddress]);

  useEffect(() => {
    if (!auth?.isLoggedIn && profile.status === 'succeeded') {
      navigate(`/${intl.locale}/cart`, { replace: true });
    } else {
      if (!auth?.isLoggedIn) {
        // navigate(`/${intl.locale}/home`, { replace: true });
      }
    }

    if (auth.status === 'succeeded' && profile.status === 'succeeded') {
      setCustomCartID(currentProfileObj?.cartId || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.draft, auth.isLoggedIn, auth.status, profile.status]);
  const profileData = JSON.parse(window.localStorage.getItem('profileDraft') || 'null');
  const isLoggedIn = profileData ? true : false;
  // const componentVariants = {
  //   hidden: {
  //     opacity: 0,
  //     x: -500,
  //   },
  //   visible: {
  //     opacity: 1,
  //     x: 0,
  //     transition: { duration: 0.3 },
  //   },
  //   exit: {
  //     opacity: 0.5,
  //     x: 0,
  //     transition: { ease: 'easeInOut' },
  //   },
  // };
  // eslint:fix componentVariants is defined but never used
  const handleslots = (val) => {
    setSelectedDate(val.date.value);
    setSlotList(val.slots);
    setSelectedTime(val.slots[0].value);
  };

  const handletime = (e) => {
    setSelectedTime(e.target.value);
  };
  const formatRelativeLocale = {
    lastWeek: "'Last' eeee",
    yesterday: "'Yesterday'",
    today: intl.formatMessage({ id: 'checkout_today' }) + ' | hh:mm a',
    tomorrow: intl.formatMessage({ id: 'checkout_tomorrow' }) + ' | hh:mm a',
    nextWeek: "'Next' eeee",
    other: 'dd.MM.yyyy',
  };
  const locale = {
    ...enGB,
    formatRelative: (token) => formatRelativeLocale[token],
  };
  const refreshCart = (mode) => {
    const couponCode = offer.apply ? offer.apply.couponCode : '';
    const items = cart.data.items;
    const payload = {
      body: {
        addressSubType: defaultAddress.addressSubType,
        addressType: defaultAddress.addressType,
        advanceTime: mode
          ? ''
          : selectedTime && selectedValue === 'future'
          ? `${format(selectedDate, 'yyyy-MM-dd')} ${selectedTime.split(' ')[1]}`
          : '',
        addressId: defaultAddress?.id || '',
        cartId: cartId,
        applySurprisePromo: couponCode?.length > 0,
        couponCode: cart.data?.couponApplied ? couponCode : '',
        clusterId: cart.data.clusterId || '',
        items: items,
        version: 'v20',
        orderType: defaultAddress.addressType,
        storeId: defaultAddress?.storeId,
      },
      headers: { country },
    };

    if (cartId) {
      dispatch(sendCart(payload)).then((res) => {
        // setTimeout(() => {
        setPageLoader(false);
        // }, 1000);

        if (res.error) {
          console.error(res.error);
        }
      });
    }
  };
  const proceedFuture = () => {
    refreshCart(false);
    setFutureDrawer(false);
  };
  const handlePaymentDrawer = () => {
    setCardNumber('');
    setSubPayment(null);
    setPaymentMode(null);
    setPaymentOpen(!paymentOpen);
  };
  const handleAddressDrawer = () => {
    setStateAddress(!stateAddress);
  };
  const handleFutureDrawer = () => {
    if (futureDrawer) {
      setSelectedTime(selectedTime ?? 0);
      setSelectedValue('now');
    }
    setFutureDrawer(!futureDrawer);
  };

  const handleLightningPayDialog = () => {
    setEnableLightningPay(false);
    closePaymentPopup();
  };

  const handleLightningPayTimerClose = () => {
    setLightningPayTimer(false);
  };

  const handleLightningPayProcessingClose = () => {
    setLightningPayProcessing(false);
  };

  const handleLightningPayStatusModalClose = () => {
    setLightningPayStatusModal(false);
  };

  const paymentTryAgainHandler = () => {
    handleLightningPayStatusModalClose();
    setPaymentOpen(true);
  };

  const navigateToProfile = () => {
    navigate(`/${context.locale}/profile`, {
      state: {
        fromPage: 'checkout',
        oldLocation: JSON.parse(JSON.stringify(location)),
      },
    });
  };
  useEffect(() => {
    shippingInfoSubmittedGA(cart, currency, categoryList, offerSelected, defaultAddress);
  }, [cart, categoryList, currency, offerSelected, defaultAddress]);

  const capitalize = ([first, ...rest], lowerRest = false) =>
    first.toUpperCase() + (lowerRest ? rest.join('').toLowerCase() : rest.join(''));

  // const orderType = Object.entries(defaultAddress).length
  //   ? capitalize(defaultAddress.addressSubType || '', true)
  //   : '';
  // eslint:fix orderType is defined but never used
  const desc = intl.formatMessage({
    id: `checkout_preference_${defaultAddress.addressSubType || 'DELIVERY'}`,
  });

  const contactLessOnChange = () => {
    setContactLessStatus(!contactLessStatus);
  };
  useEffect(() => {
    const isExist = paymentMethod?.findIndex(({ id }) => id === paymentMode);
    const payment_type = isExist !== -1 ? iconList[paymentMethod[isExist].name] : iconList['COD'];
    const heading =
      isExist !== -1 ? paymentHeading[paymentMethod[isExist].name] : paymentHeading['COD'];
    setMethodTypeIcon(payment_type);
    setMethodType(heading);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMode]);
  useEffect(() => {
    fetchUserCartsHandler();
  }, []);

  const fetchUserCartsHandler = () => {
    dispatch(fetchSavedCards())
      .then((retVal) => {
        const cardsData = retVal?.payload?.data?.data || [];
        setSaveCardData(cardsData);
      })
      .catch((error) => {
        console.error('An error occurred:', error);
      });
  };

  const toggleLighteningPayHandler = async (enable, token) => {
    const payload = {
      enableLightningPay: enable ? 1 : 0,
      token,
    };

    try {
      await dispatch(enableLightPay(payload));
      await fetchUserCartsHandler();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const onExitMemoized = React.useCallback((e) => navigate('/cart'), []);
  // eslint:fix onExitMemoized is assigned but never used
  if (cart.status !== 'succeeded') {
    return <Skeleton count={10} className={css.Skeleton} height={56} />;
  }
  const redirectToTrackOrder = (id) => {
    navigate(`/${intl.locale}/track-order/${id}`);
  };
  const fetchPaymentMethodName = (id) => {
    const op = paymentMethodConst.filter((each) => {
      return each?.name === id;
    });
    return op[0]?.value === 0 ? '0' : op[0]?.value || id;
  };
  const performAction = (event, buttonAction) => {

    if(buttonAction.type === 'CHANGE_PAY_METHOD') {
      sendOrderToMs('newOrder', null, isEnableLighteningPayOnNextOrder, null, buttonAction.action);
    } else {
      switch (buttonAction.action) {
        case 'advance-slot':
          event.preventDefault();
          if (methodType == intl.formatMessage({ id: 'checkout_pod' })) {
            setPaymentMode(null);
          }
          setStateOpen(false);
          openFuture();
          break;
        case 'checkout':
          event.preventDefault();
          setErrorType(null);
          setErrorResponse('');
          setStateOpen(false);
          break;
        case 'clevertap-notify-me':
          event.preventDefault();
          setErrorResponse('');
          setStateOpen(false);
          break;
        case 'order':
          event.preventDefault();
          setErrorResponse('');
          setStateOpen(false);
          sendOrderToMs('newOrder', null, isEnableLighteningPayOnNextOrder, null, previousPaymentMode);
          break;    
        case 'switch-payment-method':
          event.preventDefault();
          setErrorResponse('');
          setStateOpen(false);
          checkOut();
          break;
        case 'order-detail':
          event.preventDefault();
          const checkId = errorType.data.identifier.findIndex((el) => el.name === 'orderId');
          redirectToTrackOrder(errorType.data.identifier[checkId]?.value);
          setErrorResponse('');
          setStateOpen(false);
          break;
        case 'DIALER':
          setErrorType(null);
          setErrorResponse('');
          setStateOpen(false);
          // window.open('tel:' + countryValidations.customerCare);
          break;
        default:
          event.preventDefault();
          setErrorResponse('');
          setStateOpen(false);
          setErrorType(null);
  
          break;
      }
    }
  };

  const closePaymentPopup = () => {
    setCardNumber('');
    handleCardToken('');
    setSubPayment(null);
    setPaymentMode(null);
    setPaymentOpen(false);
    handleSetLastPayment();
  };

  const getCardDetailByNo = (cardNumber) => {
    let cardDetail = {};
    for (let i = 0; i < saveCardData?.userCards?.length; i++) {
      const card = saveCardData?.userCards[i];
      if (cardNumber === card.cardNo) {
        cardDetail = card;
        cardDetail.lightningPayActive = card?.isLightningBlocked === 0;
      }
    }
    return cardDetail;
  };

  const checkLightningPay = (directCard) => {
    if (reviewPop !== '') {
      // debugger;
      setReviewError((prev) => reviewPop);
    } else {
      let selectedCard = getCardDetailByNo(directCard?.cardNo || cardNumber);
      const dnd = window.localStorage.getItem('l_dnd');
      if (
        countryValidations.lightningPayConfig?.lightningPay &&
        !saveCardData.isLightningBlocked &&
        !saveCardData.isLightningBlocked &&
        cart.cartValue <= countryValidations.lightningPayConfig.lightningPayMaxAmount &&
        ((paymentMode === 1 && dnd !== 'true' && !cardNumber) ||
          selectedCard?.lightningPayActive ||
          directCard)
      ) {
        setPaymentOpen(false);
        if (selectedCard?.lightningPayActive) {
          sendOrderToMs(null, null, true, null);
        } else {
          setEnableLightningPay(true);
        }
      } else {
        sendOrderToMs();
      }
    }
  };

  return (
    <ErrorBoundary>
      {pageLoader && <Loader notToClear={true} />}
      {(!lightningPayProcessing || isDesktop) && (
        <div className={css.root}>
          <Header
            title={<FormattedMessage id="checkout" defaultMessage="Checkout" />}
            actionButtons={[<LanguageButton />]}
          />
          {isDesktop && (
            <Grid className={css.desktopContainer}>
              <div className={css.pageHeading}>
                <FormattedMessage id="checkout" defaultMessage="Checkout" />
              </div>
            </Grid>
          )}
          <main className={css.main}>
            <div className={css.firstWidget}>
              {isDesktop && (
                <div className={css.checkoutDescTitle}>
                  <h2>{desc}</h2>
                </div>
              )}
              <div className={css.wrapper}>
                {isLoggedIn && (
                  <ProfileCard
                    name={(profile.data.data && profile.data.data[0].name) || ''}
                    phone={(profile.data.data && profile.data.data[0].phnNo) || ''}
                    cCode={(profile.data.data && profile.data.data[0].cCode) || ''}
                    onChange={navigateToProfile}
                  />
                )}

                {countryValidations.advance_order_visibility && (
                  <OrderMode
                    futureError={futureError}
                    isDesktop={isDesktop}
                    selectedValue={selectedValue}
                    selectedDate={selectedDate}
                    setFutureDrawer={setFutureDrawer}
                    selectedTime={selectedTime}
                    methodType={methodType}
                    setPaymentMode={setPaymentMode}
                    onChange={handleChange}
                  />
                )}
                {defaultAddress !== 0 ? (
                  <ChangeAddressBox
                    isDesktop={isDesktop}
                    foodInstr={foodInstr}
                    handleFoodInstr={handleFoodInstr}
                    contactLessStatus={contactLessStatus}
                    contactLessOnChange={contactLessOnChange}
                  />
                ) : (
                  ''
                )}
                {goGreenConfig?.GO_GREEN_WIDGET_ENABLE === 1 && (
                  <GoGreen config={goGreenConfig} className={css.widget} />
                )}
              </div>
            </div>

            <div className={css.secondWidget}>
              <div className={css.orderSummery}>
                {isDesktop && (
                  <div className={css.sideHeading}>
                    <FormattedMessage
                      id="orderstatus_ordersummary"
                      defaultMessage="Order Summery"
                    />
                  </div>
                )}
                {isDesktop && <hr className={css.underline} />}

                <CartValue setReviewPop={setReviewPop} cart={cart} />
                {(paymentMode || cardToken) && (
                  <div className={css.latestPayment}>
                    <h3>
                      <FormattedMessage
                        id="checkout_paymentMethodHeading"
                        defaultMessage="PAYMENT METHOD"
                      />
                    </h3>

                    <div className={css.method}>
                      <div className={classNames(css.payImage, { [css.wrap]: !isDesktop })}>
                        <div className={css.cardInfo}>
                          <img
                            width="28"
                            src={cardToken ? iconList['CARD'] : methodTypeIcon}
                            alt=""
                          />

                          <div className={css.title}>
                            {console.log(`subHeading -- `, subHeading)}
                            {console.log(`methodType -- `, methodType)}
                            {console.log(`paymentMode -- `, paymentMode)}
                            {console.log(`subPayment -- `, subPayment)}
                            {cardToken && cardNumber
                              ? cardNumber
                                ? cardNumber
                                : ''
                              : methodType}{' '}
                            {subPayment !== null && paymentMode === 100 ? (
                              <span>{paymentHeading[subHeading]}</span>
                            ) : (
                              ''
                            )}
                          </div>
                          <Radio color="primary" className={css.radioStyle} checked />
                        </div>
                        <div className={css.lightningPayToggle}>
                          {countryValidations.lightningPayConfig?.lightningPay &&
                            saveCardData &&
                            cardNumber && (
                              <LightningPayToggle
                                checkLightningPay={checkLightningPay}
                                doNotShowWarning={true}
                                toggleLighteningPayHandler={toggleLighteningPayHandler}
                                cardToken={getCardDetailByNo(cardNumber)?.token}
                                checked={getCardDetailByNo(cardNumber)?.lightningPayActive}
                              />
                            )}
                        </div>
                      </div>
                      {/* {countryValidations.lightningPayConfig?.lightningPay && saveCardData && cardNumber && (
                        <div className={css.lightningPayWarningConainer}>
                          <div className={css.lightningPayWarningText}>
                            {intl.formatMessage(
                              { id: 'lightning_pay_terms_text' },
                              {
                                amount: countryValidations.lightningPayConfig?.lightningPayMaxAmount,
                                currency: countryValidations.currency,
                              }
                            )}
                          </div>
                          <RiErrorWarningLine
                            onClick={() => navigate(`/${intl.locale}/faq`)}
                            className={css.warningIcon}
                          />
                        </div>
                      )} */}
                      <div className={css.change} onClick={checkOut}>
                        <FormattedMessage
                          id="checkout_paymentOptions"
                          defaultMessage="Other Payment Options"
                        />{' '}
                        <span>
                          {/* <BsArrowRight /> */}
                          <img src={arrow} alt="Arrow" />
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {isDesktop && (
                  <div className={css.placeButton}>
                    <div className={css.buttonWrapper}>
                      <CartBar
                        miniCart={true}
                        hideInfo={true}
                        buttonText={
                          paymentMode || cardToken ? (
                            <FormattedMessage id="checkout_payment" defaultMessage="Make Payment" />
                          ) : (
                            <FormattedMessage
                              id="checkout_paymentmode"
                              defaultMessage="Select Payment Mode"
                            />
                          )
                        }
                        onClick={(e) => {
                          paymentMode || cardToken ? checkLightningPay() : checkOut(e);
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {!isDesktop && stateOpen && (
              <DrawerPwa
                variant="temporary"
                anchor="bottom"
                open={stateOpen}
                className={css.nobg}
                onClose={handleClickAway}
              >
                <CustomError
                  futureError={futureError}
                  // Badge={<Badge />}
                  errorType={errorType}
                  locale={capitalize(intl.locale)}
                  errorResponse={errorResponse}
                  performAction={performAction}
                />
              </DrawerPwa>
            )}
            {isDesktop && stateOpen && (
              <DialogBox title={''} size="sm" isOpen={stateOpen} onClose={handleClickAway}>
                <CustomError
                  futureError={futureError}
                  // Badge={<Badge />}
                  errorType={errorType}
                  locale={capitalize(intl.locale)}
                  errorResponse={errorResponse}
                  performAction={performAction}
                />
              </DialogBox>
            )}
            {!isDesktop && (
              <>
                <div className={css.bottomNav}>
                  {paymentMode || cardToken ? (
                    <div className={css.savedMethod}>
                      <div className={css.payMethod} onClick={checkOut}>
                        <div className={css.payHeading}>
                          <FormattedMessage id="checkout_payUsing" defaultMessage="Pay Using" />
                          <BsChevronDown />
                        </div>
                        <div className={css.payImage}>
                          <img
                            width="28"
                            src={cardToken ? iconList['CARD'] : methodTypeIcon}
                            alt=""
                          />
                          {cardToken && cardNumber
                            ? cardNumber
                              ? cardNumber.substring(cardNumber.length - 6)
                              : ''
                            : fetchPaymentMethodName(methodType)}
                        </div>
                      </div>
                      <div className={css.payButton}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => checkLightningPay()}
                        >
                          <FormattedMessage id="checkout_payment" defaultMessage="Make Payment" />
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <Button variant="contained" color="primary" onClick={checkOut}>
                      <FormattedMessage
                        id="checkout_paymentmode"
                        defaultMessage="Select Payment Mode"
                      />
                    </Button>
                  )}
                </div>
              </>
            )}
          </main>
          <PaymentMethodDrawer
            checkLightningPay={checkLightningPay}
            closePaymentPopup={closePaymentPopup}
            setCardNumber={setCardNumber}
            isDesktop={isDesktop}
            paymentOpen={paymentOpen}
            selectedValue={selectedValue}
            handlePaymentDrawer={handlePaymentDrawer}
            paymentApiStatus={paymentApiStatus}
            paymentMethod={paymentMethod}
            handlePayment={handlePayment}
            iconList={iconList}
            paymentHeading={paymentHeading}
            countryLightningPayStatus={countryValidations.lightningPayConfig?.lightningPay}
            lightningPayMaxAmount={countryValidations.lightningPayConfig?.lightningPayMaxAmount}
            currency={countryValidations.currency}
            paymentMode={paymentMode}
            setPaymentOpen={setPaymentOpen}
            toggleLighteningPayHandler={toggleLighteningPayHandler}
            // makePayment={sendOrderToMs}
            makePayment={() => checkLightningPay()}
            checked={checked}
            setSubPayment={setSubPayment}
            setPaymentMode={setPaymentMode}
            handleChangeCheckbox={handleChangeCheckbox}
            disableMakePayment={disableMakePayment}
            handleCardToken={handleCardToken}
            cardToken={cardToken}
          />
          {/* Payment */}
          <SavedAddressDrawer
            isDesktop={isDesktop}
            isOpen={stateAddress}
            className={css.nobg}
            onClose={handleAddressDrawer}
          />
          {!isDesktop && futureDrawer && (
            <>
              <DrawerPwa
                variant="temporary"
                anchor="bottom"
                open={futureDrawer}
                className={css.nobg}
                hideCloseButton
              >
                <FutureSlots
                  slots={slots || []}
                  selectedDate={selectedDate}
                  handleslots={handleslots}
                  formatRelative={formatRelative}
                  slotList={slotList}
                  parseISO={parseISO}
                  selectedTime={selectedTime}
                  handletime={handletime}
                  format={format}
                  proceedFuture={proceedFuture}
                  onExitMemoized={handleFutureDrawer}
                />
              </DrawerPwa>
            </>
          )}
          {isDesktop && futureDrawer && (
            <>
              <DialogBox size="sm" isOpen={futureDrawer} hideCloseButton>
                <FutureSlots
                  locale={locale}
                  slots={slots || []}
                  selectedDate={selectedDate}
                  handleslots={handleslots}
                  formatRelative={formatRelative}
                  slotList={slotList}
                  parseISO={parseISO}
                  selectedTime={selectedTime}
                  handletime={handletime}
                  format={format}
                  proceedFuture={proceedFuture}
                  onExitMemoized={handleFutureDrawer}
                />
              </DialogBox>
            </>
          )}
          {isDesktop ? (
            <DialogBox
              size="sm"
              isOpen={enableLightningPay}
              hideCloseButton
              onClose={handleLightningPayDialog}
              titleClass={css.addStyleCloseBtn}
            >
              <EnableLightningPayModal
                sendOrderToMs={sendOrderToMs}
                onClose={handleLightningPayDialog}
                isDesktop={isDesktop}
              />
            </DialogBox>
          ) : (
            <DrawerPwa
              variant="temporary"
              anchor="bottom"
              open={enableLightningPay}
              hideCloseButton
            >
              <EnableLightningPayModal
                sendOrderToMs={sendOrderToMs}
                onClose={handleLightningPayDialog}
                isDesktop={isDesktop}
              />
            </DrawerPwa>
          )}
          {isDesktop ? (
            <DialogBox hideCloseButton size="sm" isOpen={lightningPayTimer}>
              <LightningPayTimer
                currency={countryValidations.currency}
                postOrderHandler={postOrderHandler}
                onClose={handleLightningPayTimerClose}
                timerDuration={countryValidations.lightningPayPrePaymentTimer}
                cart={cart}
              />
            </DialogBox>
          ) : (
            <DrawerPwa
              variant="temporary"
              anchor="bottom"
              open={lightningPayTimer}
              className={css.nobg}
              hideCloseButton
            >
              <LightningPayTimer
                currency={countryValidations.currency}
                postOrderHandler={postOrderHandler}
                onClose={handleLightningPayTimerClose}
                timerDuration={countryValidations.lightningPayPrePaymentTimer}
                cart={cart}
              />
            </DrawerPwa>
          )}
          <DialogBox hideCloseButton size="sm" isOpen={lightningPayStatusModal}>
            <LightningPayStatus
              tryAgain={paymentTryAgainHandler}
              redirectToThankyouPage={redirectToThankyouPage}
              onClose={handleLightningPayStatusModalClose}
              success={orderId?.length > 0 ? true : false}
            />
          </DialogBox>
          <footer className={css.footer}></footer>
        </div>
      )}

      {reviewError !== '' && (
        <ReviewCartPopUp
          errorMsg={reviewPop}
          setReviewPopUp={() => setReviewError('')}
          isDesktop={isDesktop}
          // reviewCart={navigateToCart}
        />
      )}
      {isDesktop && (
        <DialogBox hideCloseButton size="sm" isOpen={lightningPayProcessing}>
          <LightningPayProcessing
            isDesktop={isDesktop}
            onClose={handleLightningPayProcessingClose}
          />
        </DialogBox>
      )}
      {!isDesktop && lightningPayProcessing && (
        <LightningPayProcessing isDesktop={isDesktop} onClose={handleLightningPayProcessingClose} />
      )}
    </ErrorBoundary>
  );
}

export default Checkout;
